<template>
  <Question
    :subtitle="$t('kyc.titles.financial')"
    :title="$t('kyc.questions.debts')"
    :sub-subtitle="$t('kyc.labels.debts')"
    :progress-ratio="1/4 + 7/12/4"
    back-route="/kyc/venture-capital"
    @next="next"
  >
    <BaseSection>
      <AmountSelects
        :amount="debtsAmount"
        :spouse-amount="spouseDebtsAmount"
        :holding-amount="holdingDebtsAmount"
        @amount="debtsAmount = $event"
        @spouse="spouseDebtsAmount = $event"
        @holding="holdingDebtsAmount = $event"
      />
    </BaseSection>
  </Question>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Question from './Question.vue';
import AmountSelects from './AmountSelects.vue';
import BaseSection from '../../components/BaseSection.vue';
import kyc from '../../mixins/kyc';

export default {
  name: 'Debts',
  components: {
    Question,
    AmountSelects,
    BaseSection,
  },
  mixins: [kyc],
  computed: mapFields('kyc', ['form.attributes.debtsAmount', 'form.attributes.spouseDebtsAmount', 'form.attributes.holdingDebtsAmount']),
  methods: {
    next() {
      this.update();
      this.$router.push('/kyc/salary');
    },
  },
};
</script>
